
import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { getOffset } from './utils';
import '../scss/_searchFilters.scss';

class pagination extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pagesCount: 0
        }
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentDidMount(){
        this.calculatePages(this.props.totalCount);
    }

    componentWillReceiveProps(nextProps) {
         if (this.props.totalCount !== nextProps.totalCount) {
            this.calculatePages(nextProps.totalCount);
         }
    }

    handlePageChange = (e, i) => {
        this.props.handlePageChange(e, i);
    }

    buildPages = () => {
        const { currentPage, handlePageChange } = this.props;
        var startPage = (currentPage + 1) - 2;
        var endPage = (currentPage + 1) + 3;

        if (startPage <= 0) {
            endPage -= (startPage - 1);
            startPage = 1;
        }
        if (endPage > (this.state.pagesCount + 1)) {
            endPage = this.state.pagesCount + 1
            startPage = (endPage - 5 > 0) ? endPage - 5 :  1;
        }

        var pages = [];
        for (let i = startPage; i < endPage; i++) {
            pages.push(<PaginationItem active={(i - 1) === currentPage} key={i - 1}>
                <PaginationLink onClick={e => handlePageChange(e, i - 1)} href="#">
                    {i}
                </PaginationLink>
            </PaginationItem>);
        }
        return pages;
    }

    getTo = (from, totalCount) => {
        const {pageSize } = this.props;
        var to = (from + pageSize) - 1;
        if (to > totalCount)
            to = totalCount;
        return to;
    }

    getFrom = (currentPage) => {
        const { pageSize } = this.props;
        return getOffset(currentPage + 1, pageSize) + 1; // add 1 since offset is 0 based
    }

    calculatePages = (totalCount) => {
        this.setState({ pagesCount: Math.ceil(((totalCount) || 0) / this.props.pageSize)});
    }

    render() {
        const { currentPage, handlePageChange } = this.props;
        return  <div className="dyna-pagination">
        <Pagination aria-label="Page navigation example" size="sm">
            <PaginationItem disabled={currentPage <= 0}>
                <PaginationLink
                    onClick={e => handlePageChange(e, currentPage - 1)}
                    previous
                    href="#" />
            </PaginationItem>
            { this.buildPages() }
            <PaginationItem disabled={currentPage >= this.state.pagesCount - 1}>
                <PaginationLink
                    onClick={e => handlePageChange(e, currentPage + 1)}
                    next
                    href="#" />
            </PaginationItem>
        </Pagination>
    </div>
    }
}

export default pagination;